<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Profilis</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="1" v-if="showNaudojimas"></v-col>
              <v-col cols="12" md="11">
                <v-row>
                  <v-col cols="12" md="7" class="pb-2" v-if="showNaudojimas">
                    <el-byla :byla="naudojimas" color="primary" with-name />
                  </v-col>
                  <v-col cols="12" md="5" class="pb-2">
                    <el-byla :byla="sauga" color="primary" with-name />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-3 mb-4" />
            <v-row>
              <v-col cols="12" md="2">Naudotojas</v-col>
              <v-col cols="12" md="10">{{ getUsername }}</v-col>
              <v-col cols="12" md="2">Įmonė</v-col>
              <v-col cols="12" md="10">{{ userKontora }}</v-col>
              <v-col cols="12" md="2">Sutartis</v-col>
              <v-col cols="12" md="10">{{ userSutartis }}</v-col>
              <v-col cols="12" md="2" v-if="isTest">Priskirtos rolės</v-col>
              <v-col cols="12" md="10" v-if="isTest">{{ userRoleList }} </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button primary @click.native.stop="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from './../../mixins/userRole'

export default {
  name: 'ModalProfile',
  mixins: [userRole],
  props: {
    title: String,
    text: String,
    action: String,
    item: Object,
    value: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getUsername', 'userKontora', 'userSutartis']),
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return this.action ? this.action : 'Delete'
    },
    userRoleList() {
      return this.userRole.join(', ')
    },
    isTest() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop' ||
        process.env.VUE_APP_LOCAL === 'test'
      )
    },
    naudojimas() {
      return {
        key: 'naudojimo-salygos',
        byl_url: `naudojimo-salygos`,
        byl_pavadinimas:
          'Susitarimas dėl testinių hipotekos ir įkeitimo duomenų teikimo.pdf',
        icon_title:
          'Susitarimas dėl testinių hipotekos ir įkeitimo duomenų teikimo',
      }
    },
    sauga() {
      return {
        key: 'saugos-nuostatai',
        byl_url: `saugos-nuostatai`,
        byl_pavadinimas: 'Saugos nuostatai.pdf',
        icon_title: 'Saugos nuostatai',
      }
    },
    showNaudojimas() {
      return false
    },
  },
  methods: {
    saveData() {
      this.closeModal()
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
